import { useState, useEffect } from 'react';
import { getSVG } from '../icons/MovementIcons';
import { SelectionButtons } from './SelectionButtons';

const BUTTONS_TIP_AND_TORQUE = [
    { label: "CentralPit", className: "centralpit", name: "Crown"},
    { label: "RotationRoot", className: "rotationroot", name: "Root" },
];

const BUTTONS_ROTATION = [
    { label: "Mesial", className: "mesial", name: "Mesial"},
    { label: "CentralPit", className: "centralpit", name: "Central" },
    { label: "Distal", className: "distal", name: "Distal" },
];

export const SkullItem = ({ type, value, unit, onIncrement, onDecrement, onValueChange, onManualChange, isStepEditMode, viewModeSingle, selectedPointRotation, selectedPointTip, selectedPointTorque }) => {
    const [inputValue, setInputValue] = useState(value);

    useEffect(() => setInputValue(value), [value]);

    const handleInputChange = (e) => setInputValue(e.target.value);

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            const numericValue = parseFloat(inputValue);
            const isValidNumber = !isNaN(numericValue);
            if (isValidNumber) {
                onValueChange(numericValue);
                onManualChange(numericValue);
            }
        }
    };

    const src = getSVG(type);

    const isRotation = type === "rotation";
    const isTorque = type === "torque";
    const isTip = type === "tip";
    const isFreeMode = !isStepEditMode;
    const isSingleView = viewModeSingle;
    const isDoubleView = !viewModeSingle;

    const showRotationSpacer = isRotation && isFreeMode && isDoubleView;
    const showTipTorqueSpacer = (isTorque || isTip) && isFreeMode && isSingleView;
    const showRotationStepSpacer = isRotation && isStepEditMode && viewModeSingle === "single";
    const rotationButtonOffset = isDoubleView ? { transform: 'translateY(-95px)' } : {};

    return (
        <div id="LeftPanelItem">
            {showRotationSpacer && <div className="rotation-spacer-container" />}

            <div id="LeftMouvementPanel">
                {showTipTorqueSpacer && <div className="tiptorque-spacer-container" />}
                {src}
                <div id="ButtonPlusAndMinus">
                    <button id="plus" onClick={onIncrement}>+</button>
                    <button id="minus" onClick={onDecrement}>-</button>
                </div>
                <div id="value-container">
                    <input type="text" value={inputValue} onChange={handleInputChange} onKeyDown={handleKeyDown} />
                    <span id="unit">{unit}</span>
                </div>

                {isFreeMode && (
                    <>
                        {isTorque && (
                            <SelectionButtons
                                type="torque"
                                options={BUTTONS_TIP_AND_TORQUE}
                                selectedPoint={selectedPointTorque}
                                actionType="SET_SELECTED_POINT_TORQUE"
                            />
                        )}
                        {isTip && (
                            <SelectionButtons
                                type="tip"
                                options={BUTTONS_TIP_AND_TORQUE}
                                selectedPoint={selectedPointTip}
                                actionType="SET_SELECTED_POINT_TIP"
                            />
                        )}
                    </>
                )}
            </div>

            {isRotation && (
                <div style={{ ...rotationButtonOffset, visibility: isFreeMode ? 'visible' : 'hidden' }}>
                    <SelectionButtons
                        type="rotation"
                        options={BUTTONS_ROTATION}
                        selectedPoint={selectedPointRotation}
                        actionType="SET_SELECTED_POINT_ROTATION"
                    />
                </div>
            )}

            {showRotationStepSpacer && <div className="rotation-spacer-container" />}
        </div>
    );
};
